module.exports = __webpack_public_path__ + "img/sound_hover_icon.74510d2b.svg";